import IconButton from '@mui/material/IconButton';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import Tooltip from '@components/Tooltip';
import { useInsertPlaceholder } from '@components/TextEditor';
import { RECOVERY_FORM_TOKEN } from '@constants/placeholders';
import { useTranslation } from '@hooks';

const RecoveryFormButton = () => {
    const { t } = useTranslation();
    const insertPlaceholder = useInsertPlaceholder();

    return (
        <Tooltip title={t('common.recoveryForm')} placement="top">
            <IconButton
                className="pl-recovery-form-btn"
                size="small"
                color="inherit"
                onClick={() => insertPlaceholder(RECOVERY_FORM_TOKEN, { padded: true })}
                aria-label={t('common.recoveryForm')}
                sx={{
                    height: 18,
                    width: 18,
                    padding: '2px !important',
                    '& svg': {
                        color: 'var(--text-secondary)',
                        fontSize: 16,
                    },
                }}
            >
                <AssignmentRoundedIcon />
            </IconButton>
        </Tooltip>
    );
};

export default RecoveryFormButton;
